import { defineComponent as F, computed as f, resolveComponent as P, openBlock as i, createElementBlock as m, createElementVNode as w, unref as d, createCommentVNode as b, createBlock as B, toDisplayString as G, createVNode as y, renderSlot as T, normalizeClass as W, ref as x, inject as $, onMounted as R, watch as N, nextTick as X, reactive as I, normalizeStyle as L, withCtx as E, Fragment as U, renderList as H, Transition as K, provide as M, onUnmounted as Y } from "vue";
const D = {
  en: {
    "flow-chart": {
      title: (t) => {
        const { normalize: o } = t;
        return o(["🇬🇧 Flow chart"]);
      }
    }
  },
  fr: {
    "flow-chart": {
      title: (t) => {
        const { normalize: o } = t;
        return o(["🇫🇷 Flow chart"]);
      }
    }
  }
}, J = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='23'%20height='26'%20fill='none'%3e%3crect%20width='17.53'%20height='6.5'%20x='4.521'%20y='2.167'%20fill='%230081F9'%20rx='.5'/%3e%3crect%20width='17.53'%20height='6.5'%20x='4.521'%20y='10.833'%20fill='%230081F9'%20rx='.5'/%3e%3crect%20width='17.53'%20height='6.5'%20x='4.521'%20y='19.5'%20fill='%230081F9'%20fill-opacity='.3'%20rx='.5'/%3e%3cpath%20stroke='%230081F9'%20stroke-linecap='round'%20stroke-width='.5'%20d='M.875.25V22.5'/%3e%3c/svg%3e", Q = { class: "flow-chart-block" }, ee = { class: "flow-chart-block-header" }, te = { class: "flow-chart-block-title" }, oe = ["src"], ne = { class: "flow-chart-block-actions" }, se = { class: "flow-chart-block-body" }, le = /* @__PURE__ */ F({
  __name: "FlowChartBlock",
  props: {
    node: {}
  },
  emits: ["open"],
  setup(t, { emit: o }) {
    const e = t, n = f(() => {
      var s;
      return (s = e.node.path) == null ? void 0 : s.length;
    });
    return (s, c) => {
      const l = P("FontAwesomeIcon");
      return i(), m("div", Q, [
        w("div", ee, [
          w("div", te, [
            e.node.type === "Diagnostic" ? (i(), m("img", {
              key: 0,
              src: d(J)
            }, null, 8, oe)) : b("", !0),
            e.node.redirection ? (i(), B(l, {
              key: 1,
              icon: ["fas", "external-link-square"],
              class: "redirect-logo"
            })) : b("", !0),
            w("div", null, G(e.node.label), 1)
          ]),
          w("div", ne, [
            d(n) ? (i(), m("button", {
              key: 0,
              onClick: c[0] || (c[0] = (r) => o("open"))
            }, [
              y(l, {
                icon: ["fas", e.node.isOpen ? "minus" : "plus"]
              }, null, 8, ["icon"])
            ])) : b("", !0)
          ])
        ]),
        w("div", se, [
          T(s.$slots, "default", {
            node: e.node
          }, void 0, !0)
        ])
      ]);
    };
  }
});
const z = (t, o) => {
  const e = t.__vccOpts || t;
  for (const [n, s] of o)
    e[n] = s;
  return e;
}, ce = /* @__PURE__ */ z(le, [["__scopeId", "data-v-3eeb3e85"]]), V = /* @__PURE__ */ F({
  __name: "ConnectorLine",
  props: {
    vertical: { type: Boolean },
    horizontal: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean }
  },
  setup(t) {
    const o = t;
    return (e, n) => (i(), m("div", {
      class: W(["line", {
        "vertical-line": o.vertical,
        "horizontal-line": o.horizontal,
        "top-line": o.top,
        "bottom-line": o.bottom
      }])
    }, null, 2));
  }
});
const re = 300, ae = (t, o) => {
  const e = x(0), n = x(1), s = $("timestamp"), c = $("zoom"), l = () => {
    if (!o.value)
      return;
    const C = o.value.getBoundingClientRect(), p = C.left + C.width / 2;
    p !== 0 && (e.value = p);
  }, r = f(() => t.index + 1 <= Math.ceil(t.total / 2)), h = f(() => t.parentX), u = f(() => Math.abs(e.value - h.value)), _ = f(() => u.value * (1 / c.value)), v = f(() => ({
    width: `${_.value * n.value}px`,
    [r.value ? "left" : "right"]: `${re / 2}px`
  }));
  return R(() => {
    l();
  }), N(s, () => {
    X(() => {
      l();
    });
  }), N(c, () => {
    n.value = 1.2, setTimeout(() => {
      l(), n.value = 1;
    }, 250);
  }), {
    xPos: e,
    connectorStyle: v
  };
}, ie = { class: "flow-chart-node shadow" }, de = {
  key: 0,
  class: "flow-chart-children",
  ref: "flowChartChildren"
}, ue = /* @__PURE__ */ F({
  __name: "FlowChartNode",
  props: {
    node: {},
    index: {},
    total: {},
    parentX: {},
    first: { type: Boolean },
    fetchContent: { type: Function },
    focusedPath: {}
  },
  emits: ["update"],
  setup(t, { emit: o }) {
    const e = t, n = I(e.node), s = async () => {
      if (n.isOpen)
        n.isOpen = !1;
      else if (n.children)
        n.isOpen = !0;
      else {
        const a = await e.fetchContent(n.id);
        n.children = a.children, n.isOpen = !0;
      }
      o("update", Date.now());
    }, c = f(() => {
      var a;
      return (a = e.node.path) == null ? void 0 : a.length;
    }), l = f(() => n.isOpen), r = x(null), h = x(null), u = () => {
      X(() => {
        h.value && (n.height = h.value.$el.getBoundingClientRect().height);
      });
    }, _ = $("timestamp"), v = async (a) => {
      if (a.children) {
        for (let g of a.children)
          if (g.redirection) {
            const S = await e.fetchContent(
              g.redirection.entityId
            );
            g.body = S.body, g.redirection.label = S.label;
          }
      }
    };
    R(() => {
      var a, g;
      (a = e.focusedPath) != null && a.length && ((g = e.focusedPath) != null && g.includes(n.id)) && s(), v(n), u();
    }), N(_, () => {
      u();
    });
    const C = (a) => {
      o("update", a);
    }, { connectorStyle: p, xPos: O } = ae(e, r);
    return (a, g) => {
      const S = P("FlowChartNode", !0);
      return i(), m("div", {
        class: "flow-chart-node-tree",
        ref_key: "flowChartNode",
        ref: r
      }, [
        w("div", ie, [
          a.first ? b("", !0) : (i(), B(V, {
            key: 0,
            vertical: "",
            top: ""
          })),
          !a.first && e.total > 1 ? (i(), B(V, {
            key: 1,
            style: L(d(p)),
            horizontal: "",
            top: ""
          }, null, 8, ["style"])) : b("", !0),
          y(ce, {
            node: e.node,
            onOpen: s,
            ref_key: "flowChartBlock",
            ref: h
          }, {
            default: E(({ node: A }) => [
              T(a.$slots, "default", { node: A }, void 0, !0)
            ]),
            _: 3
          }, 8, ["node"]),
          d(c) && d(l) ? (i(), B(V, {
            key: 2,
            vertical: "",
            bottom: ""
          })) : b("", !0)
        ]),
        d(c) && d(l) ? (i(), m("div", de, [
          (i(!0), m(U, null, H(e.node.children || [], (A, j) => {
            var Z;
            return i(), B(S, {
              node: A,
              index: j,
              "parent-x": d(O),
              total: ((Z = e.node.children) == null ? void 0 : Z.length) || 0,
              key: A.id,
              onUpdate: C,
              "fetch-content": a.fetchContent,
              "focused-path": a.focusedPath
            }, {
              default: E(({ node: q }) => [
                T(a.$slots, "default", { node: q }, void 0, !0)
              ]),
              _: 2
            }, 1032, ["node", "index", "parent-x", "total", "fetch-content", "focused-path"]);
          }), 128))
        ], 512)) : b("", !0)
      ], 512);
    };
  }
});
const he = /* @__PURE__ */ z(ue, [["__scopeId", "data-v-2111b0fa"]]), _e = { class: "flow-chart-zoom" }, pe = ["disabled"], fe = ["disabled"], me = 1, ve = 0.5, we = /* @__PURE__ */ F({
  __name: "FlowChartControls",
  emits: ["update-zoom"],
  setup(t, { emit: o }) {
    const e = $("zoom"), n = () => {
      o("update-zoom", e.value + 0.1);
    }, s = () => {
      o("update-zoom", e.value - 0.1);
    };
    return (c, l) => {
      const r = P("FontAwesomeIcon");
      return i(), m("div", _e, [
        w("button", {
          disabled: d(e) === me,
          onClick: l[0] || (l[0] = (h) => n()),
          class: "zoom-button shadow"
        }, [
          y(r, { icon: ["fas", "plus"] })
        ], 8, pe),
        w("button", {
          disabled: d(e) < ve,
          onClick: l[1] || (l[1] = (h) => s()),
          class: "zoom-button shadow"
        }, [
          y(r, { icon: ["fas", "minus"] })
        ], 8, fe)
      ]);
    };
  }
});
const ge = /* @__PURE__ */ z(we, [["__scopeId", "data-v-1763a0a1"]]), ye = { class: "mini-flow-chart-node-tree" }, Ce = {
  key: 0,
  class: "mini-flow-chart-children"
}, xe = 8, Fe = 90, ke = /* @__PURE__ */ F({
  __name: "MiniFlowChartNode",
  props: {
    node: {}
  },
  setup(t) {
    const o = t, e = f(() => o.node.children && o.node.children.length), n = f(() => ({ height: `${(o.node.height || Fe) / xe}px` }));
    return (s, c) => {
      const l = P("MiniFlowChartNode", !0);
      return i(), m("div", ye, [
        w("div", {
          class: "mini-flow-chart-node",
          style: L(d(n))
        }, null, 4),
        y(K, { name: "fade" }, {
          default: E(() => [
            d(e) && o.node.isOpen ? (i(), m("div", Ce, [
              (i(!0), m(U, null, H(o.node.children, (r) => (i(), B(l, {
                node: r,
                key: r.id
              }, null, 8, ["node"]))), 128))
            ])) : b("", !0)
          ]),
          _: 1
        })
      ]);
    };
  }
});
const be = /* @__PURE__ */ z(ke, [["__scopeId", "data-v-062ee3d3"]]), $e = { class: "mini-flow-chart" }, ze = { class: "mini-flow-chart-main-tree mini-flow-chart-main-tree-zoom" }, Oe = /* @__PURE__ */ F({
  __name: "MiniFlowChart",
  setup(t) {
    const o = $("node");
    return (e, n) => (i(), m("div", $e, [
      w("div", ze, [
        y(be, { node: d(o) }, null, 8, ["node"])
      ])
    ]));
  }
});
const Be = /* @__PURE__ */ z(Oe, [["__scopeId", "data-v-6e8f0155"]]), k = 8, Me = /* @__PURE__ */ F({
  __name: "FlowChartMinimap",
  emits: ["scroll"],
  setup(t, { emit: o }) {
    const e = $("flowChartTreeArea"), n = $("flowChartArea"), s = $("flowChartOffset"), c = f(() => ({
      width: Math.max(e.width, n.width),
      height: Math.max(e.height, n.height)
    })), l = f(() => ({
      width: `${c.value.width / k}px`,
      height: `${c.value.height / k}px`
    })), r = f(() => ({
      width: n.width + s.left < c.value.width ? n.width : c.value.width - s.left,
      height: n.height + s.top < c.value.height ? n.height : c.value.height - s.top
    })), h = f(() => ({
      width: `${r.value.width / k}px`,
      height: `${r.value.height / k}px`,
      top: `${s.top / k}px`,
      left: `${s.left / k}px`
    })), u = x(null), _ = (v) => {
      if (!u.value)
        return;
      const C = u.value.getBoundingClientRect(), p = v.clientX - C.left, O = v.clientY - C.top, a = Math.max(O * k - r.value.height / 2, 0), g = Math.max(p * k - r.value.width / 2, 0);
      o("scroll", { top: a, left: g });
    };
    return (v, C) => (i(), m("div", {
      class: "flowy-minimap",
      ref_key: "flowChartMinimap",
      ref: u,
      style: L(d(l)),
      onClick: _
    }, [
      y(Be),
      w("div", {
        class: "minimap-area",
        style: L(d(h))
      }, null, 4)
    ], 4));
  }
});
const Le = /* @__PURE__ */ z(Me, [["__scopeId", "data-v-dc17f1e1"]]), Ie = { class: "flow-chart-options" }, Ne = /* @__PURE__ */ F({
  __name: "FlowChartOptions",
  emits: ["scroll", "update-zoom"],
  setup(t, { emit: o }) {
    return (e, n) => (i(), m("div", Ie, [
      y(ge, {
        onUpdateZoom: n[0] || (n[0] = (s) => o("update-zoom", s))
      }),
      y(Le, {
        onScroll: n[1] || (n[1] = (s) => o("scroll", s))
      })
    ]));
  }
});
const Se = /* @__PURE__ */ z(Ne, [["__scopeId", "data-v-5595cc45"]]), Ae = () => {
  const t = x(1), o = f(() => ({ "--flowy-zoom": t.value })), e = (n) => {
    t.value = n;
  };
  return M("zoom", t), {
    zoom: t,
    zoomStyle: o,
    updateZoom: e
  };
};
function Te() {
  const t = window.document.querySelector("#mayday-wrapper");
  if (!t)
    return null;
  const { shadowRoot: o } = t;
  return o;
}
const Ee = (t) => {
  const o = Te() || document, e = I({ top: 0, left: 0, x: 0, y: 0 }), n = (l) => {
    var h, u;
    if (!t.value)
      return;
    [
      "flow-chart",
      "flow-chart-main-tree flow-chart-main-tree-zoom",
      "flow-chart-node-tree"
    ].includes(l.target.className) && (t.value.style.cursor = "grabbing", t.value.style.userSelect = "none", e.top = (h = t.value) == null ? void 0 : h.scrollTop, e.left = (u = t.value) == null ? void 0 : u.scrollLeft, e.x = l.clientX, e.y = l.clientY, o.addEventListener("mousemove", s), o.addEventListener("mouseup", c));
  }, s = (l) => {
    if (!t.value)
      return;
    const r = l.clientX - e.x, h = l.clientY - e.y;
    t.value.scrollTop = e.top - h, t.value.scrollLeft = e.left - r;
  }, c = () => {
    t.value && (o.removeEventListener("mousemove", s), o.removeEventListener("mouseup", c), t.value.style.cursor = "default", t.value.style.removeProperty("user-select"));
  };
  return R(() => {
    o.addEventListener("mousedown", n);
  }), Y(() => {
    o.removeEventListener("mousedown", n);
  }), {};
}, Pe = (t, o) => {
  const e = I({ width: 0, height: 0 }), n = I({ width: 0, height: 0 }), s = I({ top: 0, left: 0 });
  M("flowChartArea", e), M("flowChartTreeArea", n), M("flowChartOffset", s);
  const c = () => {
    if (!t.value)
      return;
    const { width: _, height: v } = t.value.getBoundingClientRect();
    e.width = _, e.height = v;
  }, l = () => {
    if (!o.value)
      return;
    const { width: _, height: v } = o.value.$el.getBoundingClientRect();
    n.width = _, n.height = v;
  }, r = () => {
    t.value && (s.top = t.value.scrollTop, s.left = t.value.scrollLeft);
  }, h = () => {
    setTimeout(() => {
      c(), l(), r();
    }, 250);
  }, u = () => {
    c(), l(), r();
  };
  return R(() => {
    var _;
    u(), window.addEventListener("resize", u), (_ = t.value) == null || _.addEventListener("scroll", u);
  }), Y(() => {
    var _;
    window.removeEventListener("resize", u), (_ = t.value) == null || _.removeEventListener("scroll", u);
  }), { calcBoxes: h };
}, Re = { class: "flow-chart-main-tree flow-chart-main-tree-zoom" }, Ve = /* @__PURE__ */ F({
  __name: "FlowChart",
  props: {
    focusNode: {},
    fetchContent: { type: Function }
  },
  setup(t) {
    const o = t, e = o.focusNode.ancestors, n = f(() => {
      const p = o.focusNode;
      return p.isOpen = !(e != null && e.length), p;
    });
    M("node", n);
    const s = x(Date.now());
    M("timestamp", s);
    const c = (p) => {
      s.value = p;
    }, l = x(null), r = x(null), { zoom: h, zoomStyle: u, updateZoom: _ } = Ae();
    Ee(l);
    const { calcBoxes: v } = Pe(l, r);
    N(h, () => {
      v();
    }), N(s, () => {
      v();
    });
    const C = ({ top: p, left: O }) => {
      l.value && (l.value.scrollTop = p, l.value.scrollLeft = O);
    };
    return (p, O) => {
      var a;
      return i(), m(U, null, [
        w("div", {
          id: "flow-chart",
          class: "flow-chart",
          ref_key: "flowChart",
          ref: l,
          style: L(d(u))
        }, [
          w("div", Re, [
            y(he, {
              ref_key: "flowChartTree",
              ref: r,
              node: d(n),
              "parent-x": 0,
              total: ((a = d(n).path) == null ? void 0 : a.length) || 0,
              index: 0,
              "fetch-content": p.fetchContent,
              "focused-path": d(e),
              first: "",
              onUpdate: c
            }, {
              default: E(({ node: g }) => [
                T(p.$slots, "default", { node: g }, void 0, !0)
              ]),
              _: 3
            }, 8, ["node", "total", "fetch-content", "focused-path"])
          ])
        ], 4),
        y(Se, {
          onUpdateZoom: d(_),
          onScroll: C,
          style: L(d(u))
        }, null, 8, ["onUpdateZoom", "style"])
      ], 64);
    };
  }
});
const Ue = /* @__PURE__ */ z(Ve, [["__scopeId", "data-v-da0c24d8"]]);
window.global || (window.global = window);
const De = {
  async install(t, o = {}) {
    o.i18n === void 0 && console.error("[FlowChartPlugin] 🇫🇷 i18n instance not provided"), Object.keys(D).forEach((e) => {
      var n;
      (n = o.i18n) == null || n.global.mergeLocaleMessage(e, D[e]);
    }), t.component("flow-chart", Ue);
  }
};
export {
  De as FlowChartPlugin
};
